import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Text } from '@solvhealth/jigsaw-v1';
import React from 'react';
import styled from 'styled-components';
import ResponsiveSlideInDialog from '~/components/SolvDesignSystem/Dialog/ResponsiveSlideInDialog';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';
import { analyticsTrackEvent } from '../../../core/analytics';
import { ADD_PROFILE_CANCEL, ADD_PROFILE_SUBMIT } from '../../../core/analytics/events';
import { buildDapiUserProfileObject } from '../../../core/dapi/userProfile';
import { biggerThan } from '../../../core/util/styledComponents';
import EditProfileForm from '../../Account/Profile/EditProfileForm';

const SmoothDialog = styled(Dialog).withConfig({ componentId: 'sc-1gve84s-0' })`
  -webkit-font-smoothing: antialiased;
  & .dialog-root {
    background-color: ${colors.whiteGrey};

    ${biggerThan.sm`
      padding: 20px 0;
    `}
  }
`;

const Close = styled.div.withConfig({ componentId: 'sc-1gve84s-1' })`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 26px;
  top: 20px;
  cursor: pointer;

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.blueMonday};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.blueMonday};
  }
`;

const Header = styled.div.withConfig({ componentId: 'sc-1gve84s-2' })`
  color: ${colors.squid};
  font-size: ${fontSize.large};
  font-family: ${fontFamily.bold};
  text-align: center;
  padding-top: 32px;
`;

type Props = {
  accountSummary?: any;
  closeModal: (...args: any[]) => any;
  createUserProfile: (...args: any[]) => any;
  fullScreen?: boolean;
  open: boolean;
  submitting?: boolean;
};

const AddProfileModal = (props: Props) => {
  const { open, fullScreen, closeModal, submitting, createUserProfile, accountSummary } = props;

  const onFormSubmit = (form: any) => {
    analyticsTrackEvent(ADD_PROFILE_SUBMIT);
    closeModal();

    const userProfileData = {
      ...buildDapiUserProfileObject(form),
      account_id: accountSummary.id,
      is_verified: true,
      is_hidden: false,
    };

    createUserProfile(userProfileData);
  };

  const handleCancel = () => {
    analyticsTrackEvent(ADD_PROFILE_CANCEL);
    closeModal();
  };

  return (
    <ResponsiveSlideInDialog onClose={closeModal} open={open}>
      <Text variant="h3">Add Family</Text>

      <EditProfileForm
        handleCancel={handleCancel}
        handleFormSubmit={onFormSubmit}
        showErrors
        submitting={submitting}
      />
    </ResponsiveSlideInDialog>
  );
};

export default withMobileDialog<Props>({ breakpoint: 'xs' })(AddProfileModal);
